import dispatcher from "../dispatcher"
import axios from "axios"
import FirestoreStore from "../stores/FirestoreStore"
import { EFirestoreAsyncActionType, ETimecardSequenceActionType, IPayrollTimeExport, IReportResult, ITimecardSequenceResult } from "../models"
import AppStateStore from "../stores/AppStateStore"
import strings from "../localization/strings"

export async function getUploadedDataFromSignedUrl(signedUrl: string, firestorAsyncActionType: EFirestoreAsyncActionType, asyncSessionId: string) {
    const returnData = await axios.get(signedUrl)
    const data = returnData.data
    handleAction(data, asyncSessionId, null, null, firestorAsyncActionType)
}

export async function handleAction(data: any, asyncSessionId: string, retryCb = null, successAsyncCb = null, firestorAsyncActionType: EFirestoreAsyncActionType = null, individualEmployeeLock = false) {
    const asyncSession = FirestoreStore.getAsyncSession()
    const asyncActionType = (firestorAsyncActionType !== undefined && firestorAsyncActionType !== null) ?
        firestorAsyncActionType :
        asyncSession && asyncSession.asyncSessionId === asyncSessionId ?
            asyncSession.asyncActionType :
            null

    if (data.WarningData && data.WarningData.Type && data.WarningData.Type === ETimecardSequenceActionType.LockOpenedPunchSet) {
        AppStateStore.setProgressSnackbarContent(null)
        AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.setAlertDialogContent({
            title: individualEmployeeLock ? strings.Cannot_Lock_Selected_Employees : strings.Cannot_Lock_Payroll_Hierarchy,
            content: individualEmployeeLock ?
                strings.Cannot_lock_selected_employees_because_Missing_punch_exist :
                strings.Cannot_lock_selected_Payroll_Hierarchy_because_Missing_punch_exist
        })
    }
    else if (data.WarningData && data.WarningData.Type && data.WarningData.Type === ETimecardSequenceActionType.LockSupUnapprovedPunchSet) {
        AppStateStore.setProgressSnackbarContent(null)
        AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.setAlertDialogContent({
            title: individualEmployeeLock ? strings.Cannot_Lock_Selected_Employees : strings.Cannot_Lock_Payroll_Hierarchy,
            content: individualEmployeeLock ?
                strings.Cannot_lock_selected_employees_because_supervisor_unapproved_punchset_exist :
                strings.Cannot_lock_selected_Payroll_Hierarchy_because_supervisor_unapproved_punchset_exist
        })
    }
    else if (data.WarningData && data.WarningData.Type && data.WarningData.Type === ETimecardSequenceActionType.LockSupUnapprovedExpenses) {
        AppStateStore.setProgressSnackbarContent(null)
        AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.setAlertDialogContent({
            title: individualEmployeeLock ? strings.Cannot_Lock_Selected_Employees : strings.Cannot_Lock_Payroll_Hierarchy,
            content: individualEmployeeLock ?
                strings.Cannot_lock_selected_employees_because_supervisor_unapproved_expenses_exist :
                strings.Cannot_lock_selected_Payroll_Hierarchy_because_supervisor_unapproved_expenses_exist
        })
    }
    else if (data.WarningData && data.WarningData.Type && data.WarningData.Type === ETimecardSequenceActionType.LockEmpUnapprovedPunchSet) {
        AppStateStore.setProgressSnackbarContent(null)
        AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.setAlertDialogContent({
            title: individualEmployeeLock ? strings.Cannot_Lock_Selected_Employees : strings.Cannot_Lock_Payroll_Hierarchy,
            content: individualEmployeeLock ?
                strings.Cannot_lock_selected_employees_because_employee_unapproved_punchset_exist :
                strings.Cannot_lock_selected_Payroll_Hierarchy_because_employee_unapproved_punchset_exist
        })
    }
    else if (data.WarningData && data.WarningData.Type && data.WarningData.Type === ETimecardSequenceActionType.LockEmpUnapprovedExpenses) {
        AppStateStore.setProgressSnackbarContent(null)
        AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.setAlertDialogContent({
            title: individualEmployeeLock ? strings.Cannot_Lock_Selected_Employees : strings.Cannot_Lock_Payroll_Hierarchy,
            content: individualEmployeeLock ?
                strings.Cannot_lock_selected_employees_because_employee_unapproved_expenses_exist :
                strings.Cannot_lock_selected_Payroll_Hierarchy_because_employee_unapproved_expenses_exist
        })
    }
    else if (data.WarningData && data.WarningData.Type && data.WarningData.Type === ETimecardSequenceActionType.LockSuspensePunches) {
        AppStateStore.setProgressSnackbarContent(null)
        AppStateStore.setTextProgressSnackbarContent(null)
        AppStateStore.setAlertDialogContent({
            title: individualEmployeeLock ? strings.Cannot_Lock_Selected_Employees : strings.Cannot_Lock_Payroll_Hierarchy,
            content: strings.Please_review_the_suspense_punches_before_locking_timecards
        })
    }
    else {
        switch (asyncActionType) {
            case EFirestoreAsyncActionType.GetPayrollTime:
                data.WarningData && data.WarningData.WarningItems && data.WarningData.WarningItems.length > 0 &&
                    AppStateStore.setTimecardSequenceWarningDialogContent({
                        paySettings: data.Result.PayGroupPaySettings,
                        warningData: data.WarningData
                    })
                dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.Result })
                break
            case EFirestoreAsyncActionType.LockPayrollTime:
                if (data.WarningData && data.WarningData.WarningItems && data.WarningData.WarningItems.length > 0) {
                    AppStateStore.setTimecardSequenceWarningDialogContent({
                        warningData: data.WarningData,
                        handleRetry: () => retryCb && retryCb()
                    })
                }
                else {
                    successAsyncCb ?
                        await successAsyncCb() :
                        AppStateStore.setProgressSnackbarContent(strings.Payroll_locked_successfully)
                    dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.Result })
                }
                break
            case EFirestoreAsyncActionType.EmployeeLockPayrollTime:
                if (data.WarningData && data.WarningData.WarningItems && data.WarningData.WarningItems.length > 0) {
                    AppStateStore.setTimecardSequenceWarningDialogContent({
                        warningData: data.WarningData,
                        handleRetry: () => retryCb && retryCb()
                    })
                }
                else {
                    successAsyncCb ?
                        await successAsyncCb() :
                        AppStateStore.setProgressSnackbarContent(strings.Payroll_employee_locked_successfully)
                    dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.Result })
                }
                break
            case EFirestoreAsyncActionType.UnLockPayrollTime:
                if (data.WarningData && data.WarningData.WarningItems && data.WarningData.WarningItems.length > 0) {
                    AppStateStore.setTimecardSequenceWarningDialogContent({
                        warningData: data.WarningData,
                        handleRetry: () => retryCb && retryCb()
                    })
                }
                else {
                    successAsyncCb ?
                        await successAsyncCb() :
                        AppStateStore.setProgressSnackbarContent(strings.Payroll_unlocked_successfully)
                    dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.Result })
                }
                break
            case EFirestoreAsyncActionType.EmployeeUnLockPayrollTime:
                if (data.WarningData && data.WarningData.WarningItems && data.WarningData.WarningItems.length > 0) {
                    AppStateStore.setTimecardSequenceWarningDialogContent({
                        warningData: data.WarningData,
                        handleRetry: () => retryCb && retryCb()
                    })
                }
                else {
                    successAsyncCb ?
                        await successAsyncCb() :
                        AppStateStore.setProgressSnackbarContent(strings.Payroll_employee_unlocked_successfully)
                    dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.Result })
                }
                break
            case EFirestoreAsyncActionType.ClosePayrollTime:
                if (data.WarningData && data.WarningData.WarningItems && data.WarningData.WarningItems.length > 0) {
                    data.WarningData.Type = ETimecardSequenceActionType.LockPayroll
                    AppStateStore.setTimecardSequenceWarningDialogContent({
                        warningData: data.WarningData,
                        handleRetry: () => retryCb && retryCb()
                    })
                }
                else {
                    successAsyncCb ?
                        await successAsyncCb() :
                        AppStateStore.setProgressSnackbarContent(strings.Payroll_closed_successfully)
                    dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.Result })
                }
                break
            case EFirestoreAsyncActionType.ExportPayrollTime:
                dispatcher.dispatch({ type: "SET_PAYROLL_TIME", data: data.PayrollTime })

                if (firestorAsyncActionType === EFirestoreAsyncActionType.ExportPayrollTime) {
                    // export by api case
                    const exportData: IPayrollTimeExport = data
                    setTimeout(() =>
                        dispatcher.dispatch({ type: "SHOW_EXPORT_PAYROLL_TIME_RESULT", data: exportData.ExportEmployeeIds }),
                        1000
                    )
                }
                AppStateStore.setProgressSnackbarContent(strings.Payroll_exported_successfully)
                if (data.DownloadUrl) {
                    window.location = data.DownloadUrl
                }
                break
            case EFirestoreAsyncActionType.DownloadPayrollTimeFile:
                handleDownloadWithWarning(data)
                break
            case EFirestoreAsyncActionType.DownloadPayrollTimeReport:
                handleDownloadWithWarning(data)
                break
            case EFirestoreAsyncActionType.PunchDetailReport:
                window.location = (data as IReportResult).DownloadLink
        }
    }

    clearAsyncSessionId()
}

export function clearAsyncSessionId() {
    setTimeout(() => {
        dispatcher.dispatch({ type: "UPDATE_ASYNC_SESSION_ID", data: null })
    }, 0)
}

function handleDownloadWithWarning(downloadResult: ITimecardSequenceResult) {
    downloadResult.WarningData && downloadResult.WarningData.WarningItems && downloadResult.WarningData.WarningItems.length > 0 &&
        AppStateStore.setTimecardSequenceWarningDialogContent({
            paySettings: downloadResult.Result.PayGroupPaySettings,
            warningData: downloadResult.WarningData
        })
    window.location = downloadResult.Result.DownloadLink
}